(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ep-card-product"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'ep-wishlist';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function sync(btn, list) {
      var h = btn.getAttribute('data-handle');
      btn.classList.toggle('is-on', list.indexOf(h) !== -1);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ep-fav]');
      if (!btn) return;
      e.preventDefault();
      var h = btn.getAttribute('data-handle');
      var list = read();
      var i = list.indexOf(h);
      if (i === -1) { list.push(h); } else { list.splice(i, 1); }
      write(list);
      document.querySelectorAll('[data-ep-fav][data-handle="' + h + '"]').forEach(function (b) { sync(b, list); });
      document.dispatchEvent(new CustomEvent('ep:wishlist:changed'));
    });
    document.addEventListener('DOMContentLoaded', function () {
      var list = read();
      document.querySelectorAll('[data-ep-fav]').forEach(function (b) { sync(b, list); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ep-facet-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-ep-coll]').forEach(function (root) {
      if (root.dataset.epCollInit) return;
      root.dataset.epCollInit = '1';
      var form = root.querySelector('[data-ep-coll-form]');

      var sort = root.querySelector('[data-ep-sort]');
      if (sort) { sort.addEventListener('change', function () { if (form) form.submit(); }); }

      if (form) {
        form.querySelectorAll('.ep-coll__fopt input[type="checkbox"]').forEach(function (cb) {
          cb.addEventListener('change', function () { form.submit(); });
        });
        form.querySelectorAll('[data-ep-fsearch]').forEach(function (inp) {
          inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
        });
      }

      root.querySelectorAll('[data-ep-price]').forEach(function (box) {
        var lo = box.querySelector('[data-ep-price-min]');
        var hi = box.querySelector('[data-ep-price-max]');
        if (!lo || !hi) return;
        var fill = box.querySelector('[data-ep-price-fill]');
        var outLo = box.querySelector('[data-ep-price-lo]');
        var outHi = box.querySelector('[data-ep-price-hi]');
        var gte = box.querySelector('[data-ep-price-gte]');
        var lte = box.querySelector('[data-ep-price-lte]');
        var ceiling = parseInt(hi.max, 10) || 0;
        var cur = box.getAttribute('data-currency') || '';
        if (ceiling <= 0) return;

        function money(n) { return n.toFixed(2).replace('.', ','); }

        function clamp(moved) {
          var a = parseInt(lo.value, 10);
          var b = parseInt(hi.value, 10);
          if (a > b) {
            if (moved === lo) { lo.value = b; } else { hi.value = a; }
          }
        }

        function paint() {
          var a = parseInt(lo.value, 10);
          var b = parseInt(hi.value, 10);
          if (outLo) outLo.textContent = money(a) + ' ' + cur;
          if (outHi) outHi.textContent = money(b) + (b >= ceiling ? '+' : '') + ' ' + cur;
          if (fill) {
            fill.style.left = (a / ceiling * 100) + '%';
            fill.style.right = (100 - b / ceiling * 100) + '%';
          }
        }

        function sync() {
          var a = parseInt(lo.value, 10);
          var b = parseInt(hi.value, 10);
          if (gte) { gte.value = a; gte.disabled = a <= 0; }
          if (lte) { lte.value = b; lte.disabled = b >= ceiling; }
        }

        [lo, hi].forEach(function (inp) {
          inp.addEventListener('input', function () { clamp(inp); paint(); });
          inp.addEventListener('change', function () {
            clamp(inp);
            paint();
            sync();
            if (form) form.submit();
          });
        });

        paint();
      });

      root.querySelectorAll('[data-ep-fmore]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var body = btn.closest('.ep-coll__fg-body');
          var extra = body.querySelectorAll('.ep-coll__fopt--extra');
          var hidden = body.querySelector('.ep-coll__fopt--extra.is-hidden');
          if (hidden) {
            extra.forEach(function (o) { o.classList.remove('is-hidden'); });
            btn.textContent = 'Mostra meno ▴';
          } else {
            extra.forEach(function (o) { o.classList.add('is-hidden'); });
            btn.textContent = 'Mostra altri (' + extra.length + ') ▾';
          }
        });
      });

      root.querySelectorAll('[data-ep-fsearch]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var body = inp.closest('.ep-coll__fg-body');
          var q = inp.value.toLowerCase().trim();
          var any = false;
          body.querySelectorAll('[data-ep-fopt]').forEach(function (o) {
            var t = o.querySelector('.ep-coll__lab').textContent.toLowerCase();
            var show = !q || t.indexOf(q) !== -1;
            o.style.display = show ? '' : 'none';
            if (show) any = true;
            if (q && show) o.classList.remove('is-hidden');
          });
          var none = body.querySelector('[data-ep-fnone]');
          if (none) none.style.display = any ? 'none' : 'block';
          var more = body.querySelector('[data-ep-fmore]');
          if (more) more.style.display = q ? 'none' : '';
        });
      });

      var grid = root.querySelector('[data-ep-grid]');
      var vGrid = root.querySelector('[data-ep-view-grid]');
      var vList = root.querySelector('[data-ep-view-list]');
      function setView(list) {
        if (!grid) return;
        grid.classList.toggle('ep-coll__grid--list', list);
        if (vGrid) vGrid.classList.toggle('is-on', !list);
        if (vList) vList.classList.toggle('is-on', list);
        try { localStorage.setItem('ep-coll-view', list ? 'list' : 'grid'); } catch (e) {}
      }
      if (vGrid) vGrid.addEventListener('click', function () { setView(false); });
      if (vList) vList.addEventListener('click', function () { setView(true); });
      /* Su telefono la vista elenco e il default (scelta cliente); la preferenza
         toccata dall'utente, salvata in localStorage, vince in entrambi i sensi. */
      try {
        var savedView = localStorage.getItem('ep-coll-view');
        if (savedView === 'list' || (!savedView && window.matchMedia('(max-width: 749px)').matches)) setView(true);
      } catch (e) {}

      var panel = root.querySelector('[data-ep-coll-panel]');
      var scrim = root.querySelector('[data-ep-coll-scrim]');
      function openP() { if (panel) panel.classList.add('is-open'); if (scrim) scrim.classList.add('is-on'); }
      function closeP() { if (panel) panel.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-on'); }
      var openBtn = root.querySelector('[data-ep-coll-open]');
      var closeBtn = root.querySelector('[data-ep-coll-close]');
      if (openBtn) openBtn.addEventListener('click', openP);
      if (closeBtn) closeBtn.addEventListener('click', closeP);
      if (scrim) scrim.addEventListener('click', closeP);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ep-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-ep-mega]').forEach(function (nav) {
      /* Accordion: il chevron espande/collassa il livello successivo (il testo resta un link) */
      nav.querySelectorAll('[data-ep-mega-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var row = btn.closest('.ep-mega__row');
          var body = row ? row.nextElementSibling : null;
          if (!body) return;
          var open = body.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      /* Chiusura drawer: X, click fuori dal pannello, Esc */
      function closeDrawer() {
        nav.classList.remove('ep-mega--open');
      }
      /* Qualunque click fuori dal pannello del drawer (scrim o area nav vuota) chiude.
         Robusto anche se lo scrim non copre l'area: intercetta sul nav stesso. */
      nav.addEventListener('click', function (e) {
        if (!nav.classList.contains('ep-mega--open')) return;
        if (e.target.closest('[data-ep-mega-close]')) { closeDrawer(); return; }
        if (!e.target.closest('.ep-mega__bar')) closeDrawer();
      });
      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape' && nav.classList.contains('ep-mega--open')) closeDrawer();
      });

      /* Blocco scroll del body quando il drawer è aperto (sincronizzato col burger) */
      new MutationObserver(function () {
        document.body.classList.toggle('ep-mega-lock', nav.classList.contains('ep-mega--open'));
      }).observe(nav, { attributes: true, attributeFilter: ['class'] });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
